import React from 'react';

/**
 * Mission target — stamped tin badge to match the robot pieces.
 * Filled plate + walnut outline + inner ring + glint. No <defs>/gradients:
 * url(#id) fragment refs break under CRA's <base href>.
 */
function CircleIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      style={{ display: 'block' }}
    >
      <circle cx="16" cy="16" r="12" fill={color} stroke="#2a1a0e" strokeWidth="1.8" />
      <circle cx="16" cy="16" r="7.4" fill="none" stroke="#fff" strokeOpacity="0.4" strokeWidth="1.6" />
      <circle cx="11.4" cy="11" r="1.5" fill="#fff" opacity="0.5" />
    </svg>
  );
}

export default CircleIcon;
